import { useCommandArgs } from '~/components/command-menu/hooks/useCommandArgs'
import { useDisplayName } from '~/hooks/useDisplayName'
import { IAddress } from '~/types'

export const CommandContextDecoration = () => {
  const { contextArgs } = useCommandArgs()

  // don't show a decoration if the active view is not the default view
  if (contextArgs.activeView !== 'default') return null

  if (contextArgs.address) {
    return <AddressDecoration address={contextArgs.address} />
  }

  return null
}

const AddressDecoration = ({ address }: { address: IAddress }) => {
  const { smartAccountName } = useDisplayName(address)
  return (
    <div className="flex w-full p-2 pb-0">
      <div className="flex min-w-0 items-center gap-0.5 rounded-lg bg-gray-100 px-2 py-1.5 text-xs leading-none dark:bg-gray-800">
        <span className="text-secondary">Account •</span>
        <span>{smartAccountName}</span>
      </div>
    </div>
  )
}
